<template>
  <p-container class="widget event registration form">
    <p-row column nowrap>
      <p-col shrink>
        <h2>{{ $t('page.event-registration-configuration.title') }}</h2>
      </p-col>
      <p-col shrink>
        <p-card>
          <p-row>
            <p-col xs12 sm6 md4 lg3>
              <p-select
                v-model="widgetConfig.language"
                :label="$t('page.settings.title.languageSettings')"
                :items="languages"
              ></p-select>
            </p-col>
            <p-col xs12 sm6 md4 lg3>
              <p-number-field
                v-model="widgetConfig['widget-event-businessunitnumber']"
                :label="$t('page.event-registration-configuration.businessUnitNumber.label')"
                no-steppers
              ></p-number-field>
            </p-col>
            <p-col xs12 sm6 md4 lg3>
              <p-text-field
                v-model="widgetConfig['widget-event-eventid']"
                :label="$t('page.event-registration-configuration.eventId.label')"
                required
              ></p-text-field>
            </p-col>
            <p-col xs12 sm6 md4 lg3>
              <p-text-field
                v-model="widgetConfig['widget-event-partyroleid']"
                :label="$t('page.event-registration-configuration.title.partyRoleId')"
                required
              ></p-text-field>
            </p-col>
            <p-col xs12 sm6 md4 lg3>
              <p-text-field
                v-model="widgetConfig['widget-event-registrationsuccessurl']"
                label="Success URL"
                required
              ></p-text-field>
            </p-col>
            <p-col xs12 sm6 md4 lg3>
              <p-text-field
                v-model="widgetConfig['widget-event-registrationtitle']"
                :label="$t('page.event-registration-configuration.title.label')"
              ></p-text-field>
            </p-col>
            <p-col xs12 sm6 md4 lg3>
              <p-text-field
                v-model="widgetConfig['widget-event-addressownernumber']"
                :label="$t('page.event-registration-configuration.addressownernumber.label')"
                required
              ></p-text-field>
            </p-col>

            <p-col :xs12="!$media.isDesktop" :justify-end="!$media.isDesktop" align-end>
              <p-button :disabled="widgetIsLoading" @click="openWidget(widgetConfig['widget-event-eventid'], widgetConfig['widget-event-partyroleid'], widgetConfig['widget-event-businessunitnumber'], widgetConfig.language, widgetConfig['widget-event-registrationtitle'], widgetConfig['widget-event-registrationsuccessurl'], widgetConfig['widget-event-addressownernumber'])">
                {{ $t('core.app.ok') }}
              </p-button>
              <p-button :title="$t('widget.config-pages.embed-info.hint')" class="ml-2" secondary @click="toggleWidgetEmbedInfo()">
                <p-icon :color="isWidgetEmbedInfoVisible ? 'base' : undefined">
                  dataset_linked
                </p-icon>
                <p-icon right>
                  {{ isWidgetEmbedInfoVisible ? 'expand_less' : 'expand_more' }}
                </p-icon>
              </p-button>
            </p-col>
          </p-row>
          <p-container v-if="errorMessage">
            <p-alert :value="true" type="error">
              {{ errorMessage }}
            </p-alert>
          </p-container>
        </p-card>
      </p-col>
      <p-card v-if="isWidgetEmbedInfoVisible" class="ma-0">
        <div v-if="!link">
          {{ $t('widget.config-pages.embed-info.no-link-message') }}
        </div>
        <template v-else>
          <p-col shrink>
            <p-row align-center>
              <p-col shrink>
                <a ref="link" :href="link" target="_blank" rel="noopener noreferrer">{{ link }}</a>
              </p-col>
              <p-col grow>
                <p-row dense>
                  <p-button secondary @click="_.copyToClipboard($refs.link)">
                    <p-icon>content_copy</p-icon>
                  </p-button>
                </p-row>
              </p-col>
            </p-row>
          </p-col>
          <p-divider class="mb-4"></p-divider>
          <p-col>
            <p-row>
              <p-col grow>
                <pre ref="widgetEmbedCode" class="code overflow-auto">{{ widgetEmbedSnippet }}</pre>
              </p-col>
              <p-col shrink :xs12="!$media.isDesktop">
                <p-button secondary @click="_.copyToClipboard($refs.widgetEmbedCode)">
                  <p-icon>content_copy</p-icon>
                </p-button>
              </p-col>
            </p-row>
          </p-col>
        </template>
      </p-card>
      <template v-if="link">
        <p-col>
          <div id="result" class="fill-height fill-width">
            <!-- WIDGET RENDERED HERE -->
          </div>
        </p-col>
      </template>
    </p-row>
  </p-container>
</template>
<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    auth: true,
    role: ['Admin', 'HostAdmin'],
    data: () => ({
      isWidgetEmbedInfoVisible: false,
      errorMessage: undefined as string | undefined,
      widgetHost: `${window.location.protocol}//${window.location.host}`,
      widgetConfig: {
        'mount-id': 'widget-event-registration-id',
        route: '_widgets/event/registration',
        language: 'de',

        'widget-event-eventid': undefined as string | undefined,
        'widget-event-registrationsuccessurl': undefined as string | undefined,
        'widget-event-businessunitnumber': undefined as string | undefined,
        'widget-event-partyroleid': undefined as string | undefined,
        'widget-event-registrationtitle': undefined as string | undefined,
        'widget-event-addressownernumber': undefined as number | undefined,
      },
      widgetEmbedSnippet: undefined as string | undefined,
      link: undefined as string | undefined,
      host: `${window.location.protocol}//${window.location.host}`,
      widgetIsLoading: false as boolean,

    }),
    computed: {
      languages(): { id: string, caption: string, description: string }[] {
        return this.$translation.availableAppLanguages.map((lang) => ({
          id: lang.toLowerCase(),
          caption: this.$t(`app.language.${lang.toLowerCase()}`),
          description: lang.toLowerCase(),
        }));
      },
    },
    mounted() {
      this.widgetConfig.language = this.$config.getQueryOrValue('language') ?? this.widgetConfig.language;

      this.widgetConfig['widget-event-eventid'] = this.$config.getQueryOrValue('widget-event-eventid', 'eventId') ?? this.widgetConfig['widget-event-eventid'];
      this.widgetConfig['widget-event-registrationsuccessurl'] = this.$config.getQueryOrValue('widget-event-registrationsuccessurl', 'successUrl') ?? this.widgetConfig['widget-event-registrationsuccessurl'];
      this.widgetConfig['widget-event-businessunitnumber'] = this.$config.getQueryOrValue('widget-event-businessunitnumber', 'businessUnit') ?? this.widgetConfig['widget-event-businessunitnumber'];
      this.widgetConfig['widget-event-registrationtitle'] = this.$config.getQueryOrValue('widget-event-registrationtitle', 'registrationTitle') ?? this.widgetConfig['widget-event-registrationtitle'];
      this.widgetConfig['widget-event-partyroleid'] = this.$config.getQueryOrValue('widget-event-partyroleid', 'eventPartyRole') ?? this.widgetConfig['widget-event-partyroleid'];
      this.widgetConfig['widget-event-addressownernumber'] = +(this.$config.getQueryOrValue('widget-event-addressownernumber', 'contactAddressOwnerNumber') ?? this.widgetConfig['widget-event-addressownernumber'] ?? '');
    },
    methods: {
      createWidgetEmbedSnippet(scriptQueries?: Record<string, string>) {
        const widgetConfig = this.widgetConfig as Record<string, any>;
        const widgetAttributes = Object.keys(widgetConfig)
          .filter((key) => widgetConfig[key] !== undefined)
          .map((key) => `data-${key}="${widgetConfig[key]}"`)
          .join('\n ');
        const queries = scriptQueries ? `?${Object.keys(scriptQueries).map((i) => `${i}=${scriptQueries[i]}`).join('&')}` : '';
        return `
          <link href="${this.widgetHost}/css/app.css" rel="stylesheet" />
          <div id="${widgetConfig['mount-id']}"></div>
            <script
              async="async"
              data-router-mode="abstract"
              data-config-path="${this.widgetHost}"
              data-auth-apikey="GL-*****************************"
              src="${this.widgetHost}/js/app.js${queries}"
              ${widgetAttributes}
            ><\/script>`
          .replace(/[ \t]+/g, ' ')
          .replace(/^[ \t]/gm, '')
          .trim();
      },
      toggleWidgetEmbedInfo() {
        this.isWidgetEmbedInfoVisible = !this.isWidgetEmbedInfoVisible;
      },
      async openWidget(eventId:string, partyRoleId: string, businessUnit: number, language: string, title:string, successUrl:string, addressOwnerNumber:number) {
        if (this.widgetIsLoading) return;
        try {
          this.errorMessage = undefined;
          if (this._.isEmpty(eventId)) {
            this.errorMessage = 'Please enter an event Id';
            return;
          }
          if (this._.isEmpty(partyRoleId)) {
            this.errorMessage = 'Please enter a party role Id';
            return;
          }
          if (this._.isEmpty(successUrl)) {
            this.errorMessage = 'Enter a URL for the redirect after successful payment';
            return;
          }
          if (this._.isEmpty(addressOwnerNumber)) {
            this.errorMessage = 'Enter a AddressOwnerNumber for the contact';
            return;
          }
          this.widgetIsLoading = true;
          const queries = {
            eventId, businessUnit: businessUnit?.toString(), language, title, successUrl, partyRoleId, addressOwnerNumber: addressOwnerNumber.toString(),
          } as Record<string, string>;
          const queryString = Object.keys(queries)
            .filter((key) => queries[key] !== undefined && queries[key] !== null && queries[key] !== '')
            .map((key) => `${key}=${encodeURIComponent(queries[key])}`)
            .join('&');
          this.link = new URL(`${this.widgetHost}/${this.widgetConfig.route}?${queryString}`, document.baseURI).href;
          this.widgetEmbedSnippet = this.createWidgetEmbedSnippet({ cacheBust: Date.now().toString() });
          this.$nextTick(() => {
            const resultElement = document.getElementById('result') as HTMLElement;
            const contextElement = document.createRange().createContextualFragment(this.widgetEmbedSnippet!);
            resultElement.replaceChildren(contextElement);
            setTimeout(() => { this.widgetIsLoading = false; }, 1000);
          });
        } catch {
          this.widgetIsLoading = false;
        }
      },
    },
  });
  </script>
